let screenW = $(window).width()
let screenH = $(window).height()

function breakpoint(breakpoint)
{
  let breakpoints = {
    'xs': 0,
    'sm': 576,
    'md': 767,
    'lg': 1200,
    'xl': 1280,
    'xxl': 1440,
    'screenW': screenW,
    'screenH': screenH,
  }
  return breakpoints[breakpoint]
}

function breakpointUp(value)
{
  return breakpoint('screenW') >= breakpoint(value)
}

function breakpointDown(value)
{
  return breakpoint('screenW') < breakpoint(value)
}


export { breakpoint, breakpointUp, breakpointDown }
